import { createStore } from 'vuex'

import user from './modules/user'
import setting from './modules/setting'
import tagView from './modules/tagView'
import condition from './modules/condition'
import notice from './modules/notice'
import topMenu from './modules/topMenu'
import leftMenu from './modules/leftMenu'

var store = createStore({
   state: {
   },
    modules: {
        user: user,
        setting: setting,
        tagView:tagView,
        condition:condition,
        notice: notice,
        topMenu: topMenu,
        leftMenu: leftMenu
      }
})

export default store;

